// client/src/pages/doctors/JournalEntryDetail.jsx
import React from 'react';
import JournalEntryDetailComponent from '../../components/doctors/JournalReview/JournalDetails';

const JournalEntryDetail = () => {
  return <JournalEntryDetailComponent />;
};

export default JournalEntryDetail;